export var ChannelType;
(function (ChannelType) {
    ChannelType[ChannelType["None"] = 0] = "None";
    ChannelType[ChannelType["Fixed"] = 1] = "Fixed";
    ChannelType[ChannelType["Removable"] = 2] = "Removable";
    ChannelType[ChannelType["Disabled"] = 3] = "Disabled";
})(ChannelType || (ChannelType = {}));
